var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6014 3.39886C12.9334 3.73081 12.9334 4.269 12.6014 4.60094L4.60143 12.6009C4.26949 12.9329 3.7313 12.9329 3.39935 12.6009C3.0674 12.269 3.0674 11.7308 3.39935 11.3989L11.3994 3.39886C11.7313 3.06692 12.2695 3.06692 12.6014 3.39886Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39935 3.39886C3.7313 3.06692 4.26949 3.06692 4.60143 3.39886L12.6014 11.3989C12.9334 11.7308 12.9334 12.269 12.6014 12.6009C12.2695 12.9329 11.7313 12.9329 11.3994 12.6009L3.39935 4.60094C3.0674 4.269 3.0674 3.73081 3.39935 3.39886Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.04536f1096fdd04ed8c9f9c366cada9b.svg";
export { ForwardRef as ReactComponent };